import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { IntegrationInvite } from '../../models/integrationInvite';
import { Observable } from 'rxjs';
import {TraaqrTag} from "../../models/traaqrTag";

interface InviteByTokenResponse {
  invite: IntegrationInvite;
  tag: TraaqrTag
}

export class IntegrationInviteDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.INTEGRATIONINVITE, apiHelper);
  }

  public getInvite(token: string): Observable<InviteByTokenResponse> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/byToken/' + token;
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'GET', null, null, headers, null);
  }

  public markComplete(id: string): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/' + id + '/mark-complete';
    let headers = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall(url, 'POST', null, null, headers, null);
  }
}
